import React from "react";

const BooleanRenderer = (props) => {
    switch (props.value) {
        case true:
            return (<span><i className="color-vert cell-render-icon fas fa-circle" /></span>);
        default:
            return (<span><i className="color-rouge cell-render-icon fas fa-circle" /></span>);
    }
}

export default BooleanRenderer;